import { SystemCurrency } from '@okletsplay/core';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { convertCryptoToUsd, selectToFiatExchangeRate } from 'shared/utils';
import { exchangeRatesSelector } from '../store/exchange-rates/selectors';
import { userPaymentAccountsSelector } from '../store/user-payment-accounts/selectors';

export const useBalancesConfig = (showOnlyActive = true) => {
  const exchangeRates = useSelector(exchangeRatesSelector.all);
  const accounts = useSelector(
    showOnlyActive
      ? userPaymentAccountsSelector.getActiveAccounts
      : userPaymentAccountsSelector.getSupportedAccounts
  );

  const balancesConfig = useMemo(() => {
    return accounts.map((account) => {
      return {
        account,
        fiatEquivalent: convertCryptoToUsd(
          account.balance,
          selectToFiatExchangeRate(exchangeRates, account.currency)
        ),
        isRateVisible: account.currency !== SystemCurrency.USDT,
      };
    });
  }, [accounts, exchangeRates]);

  return { balancesConfig };
};
